var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 47,
    viewBox: "0 0 70 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFE3E8",
    d: "M69.1 5.8v34.5c0 3.2-2.6 5.8-5.7 5.8H5.8c-.7 0-1.4-.1-2-.4-2.3-.8-3.8-3-3.8-5.4V5.8C0 2.6 2.6 0 5.8 0h57.6C66.5 0 69 2.6 69 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE7623",
    d: "M69.1 23v17.3c0 3.2-2.6 5.8-5.8 5.8H4.9c-.7 0-1.4-.1-2-.4a213 213 0 0014.3-2.5l3.6-.8C40 38 56.8 31.6 66.2 25.2l3-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M8.4 15.3H5.8v9.2h2.6a5 5 0 003.3-1 4.6 4.6 0 00-3.3-8.2zm2.1 7c-.7.5-1.6.8-2.5.7h-.4v-6H8c1-.1 1.8.2 2.5.7a3 3 0 011 2.3 3 3 0 01-1 2.3zm3.7-7H16v9.3h-1.8zm6.2 3.6c-1-.4-1.4-.7-1.4-1.2s.5-1 1.3-1c.6 0 1.1.3 1.4.7l1-1.2a4 4 0 00-2.7-1 2.7 2.7 0 00-3 2.6c0 1.3.7 2 2.4 2.5l1.2.6c.3.2.6.5.6 1a1.3 1.3 0 01-1.5 1.2c-.8 0-1.6-.4-2-1.2l-1 1.1c.7 1.2 2 1.8 3.3 1.8a3 3 0 003.1-3c0-1.5-.5-2.2-2.6-3zm3.2 1a4.8 4.8 0 005 4.9 5 5 0 002.2-.6v-2.1c-.6.6-1.4 1-2.2 1a3 3 0 01-3.1-3.2 3 3 0 013-3.2 3 3 0 012.3 1v-2c-.7-.4-1.5-.6-2.2-.6a4.9 4.9 0 00-5 4.8zm21.5 1.6l-2.5-6.2h-2l4 9.5h1l4-9.5h-2zm5.2 3h5.2V23H52v-2.5h3.2v-1.6H52v-2h3.4v-1.6h-5.2zm10.2-3.8a2.5 2.5 0 002-2.7c0-1.7-1.1-2.7-3.2-2.7h-2.7v9.2h1.9v-3.7h.2l2.5 3.7h2.2l-3-3.8zM59 19.6h-.5v-2.8h.5c1.1 0 1.7.4 1.7 1.4 0 1-.6 1.4-1.7 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE7623",
    d: "M41.2 20a5 5 0 11-9.8 0 5 5 0 019.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M63.4 15.7l.1-.2c0-.2 0-.3-.3-.3H63v.9h.2v-.4l.3.4h.2l-.2-.4zm-.2-.1v-.2h.1v.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M63.3 15a.7.7 0 100 1.4.7.7 0 000-1.5zm.3 1c0 .2-.2.2-.3.2a.6.6 0 01-.6-.6.5.5 0 011.1 0c0 .2 0 .4-.2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.2f28e73acd606460d93c171ec3ea4b76.svg";
export { ForwardRef as ReactComponent };